import { Link } from '@chakra-ui/react';
import React from 'react';
import { hexToRGBA } from '../utils/hexToRGBA';

export default function ChildLink(props) {
    const { navLink,application} = props
    
    const brandColor = application.theme.colors.brand.primary;

    const linkStyles = {
      fontSize: '12px',
      fontWeight: 500,
      color: 'neutral.1500',
      paddingY: 2,
      paddingLeft: 7,
      borderRadius: '8px',
      _hover: {
        cursor: 'pointer',
        backgroundColor: hexToRGBA(brandColor, 0.1),
      },
    };
  
    return (
      <Link href={navLink.route} sx={linkStyles}>
        {navLink.name}
      </Link>
    ) 
}